import LinkButton from '@atoms/LinkButton';
import RelatedArticleCard from '@molecules/RelatedArticleCard';
import type { ReactElement } from 'react';

//TODO: Create version for large mobile
import { ButtonWrapper, CardsWrapper, Wrapper } from './RelatedArticles.styled';
import type { RelatedArticlesProps } from './RelatedArticles.types';

export const RelatedArticles = ({
  title,
  buttonTitle,
  buttonLink,
  cards,
}: RelatedArticlesProps): ReactElement => {
  if (!cards.length) return null;

  return (
    <Wrapper>
      <h2>{title}</h2>
      <CardsWrapper>
        {cards.slice(0, 3).map(card => (
          <RelatedArticleCard key={card.title} {...card} />
        ))}
      </CardsWrapper>
      <ButtonWrapper>
        <LinkButton link={buttonLink}>{buttonTitle}</LinkButton>
      </ButtonWrapper>
    </Wrapper>
  );
};
